export default __webpack_public_path__ + "static/media/vi-icon.a3cb7800.svg";